// extracted by mini-css-extract-plugin
export var fileUpload = "_gp-1";
export var modalButton = "_gp-0";